import { useEffect } from 'react'
import { useChatStore } from '@/store/chatStore'

// ─────────────────────────────────────────────
// ThemeProvider
// Sets data-theme on <html> element based on
// config passed from loader.js via URL param.
// All CSS variables in themes.css react to this.
// ─────────────────────────────────────────────

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const config = useChatStore((s) => s.config)

  useEffect(() => {
    if (config?.theme) {
      document.documentElement.setAttribute('data-theme', config.theme)
    }
  }, [config?.theme])

  return <>{children}</>
}